module.exports = __webpack_public_path__ + "static/media/piece1.a5c72093.png";